import * as NUMBER from 'constant/number'
import React, { useState } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { addTag } from 'action/tag'
import { Form, Modal } from 'antd'
import PropTypes from 'prop-types'
import TagForm from 'view/page/tag-management/component/tag-form'
import FormModal from 'view/component/form-modal'

const { success, error } = Modal

const buildSuccessObject = (response) => ({
  centered: true,
  content: response.message,
  title: 'Tag created'
})

const buildErrorObject = (response) => ({
  centered: true,
  content: response.message,
  title: 'An Error has occured'
})

const NewTag = ({ addTag, submitting, site }) => {
  const [visible, setVisible] = useState(false)
  const [form] = Form.useForm()
  const handleClick = () => setVisible(true)

  const handleSubmit = () => {
    form.validateFields().then(async (values) => {
      values.site = site.site_uuid
      const response = await addTag(values)
      setVisible(false)
      form.resetFields()
      !response.error ? success(buildSuccessObject(response)) : error(buildErrorObject(response))
    }).catch(({ errorFields }) => form.scrollToField(errorFields[NUMBER.ZERO].name[NUMBER.ZERO]))
  }

  return (
    <>
      <a onClick={handleClick}>New Tag</a>
      <FormModal
        handleSubmit={handleSubmit}
        loading={submitting}
        onCancel={() => {
          setVisible(false)
          form.resetFields()
        }}
        title='New Tag'
        visible={visible}
      >
        <TagForm
          form={form}
          site={site}
        />
      </FormModal>
    </>
  )
}

NewTag.propTypes = {
  addTag: PropTypes.func,
  site: PropTypes.object,
  submitting: PropTypes.bool
}

const mapStateToProps = (state) => ({
  submitting: state.loader.tagSubmitting
})

const mapDispatchToProps = (dispatch) => ({
  addTag: bindActionCreators(addTag, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(NewTag)
